import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementConfig } from "./CareElementConfig";

class CareComponentConfig {
    public Name: string;
    public CareElementsConfig: CareElementConfig[] = [];
    public Expanded?: boolean;
    public IsActive?: boolean = false;

    public constructor(init?: NonFunctionProperties<CareComponentConfig>) {
        Object.assign(this, init);
    }
}

export { CareComponentConfig };
